import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { TermsOfUseMaterialModule } from './terms-of-use-material-modules.module';
import { TermsOfUseComponent } from './terms-of-use.component';

@NgModule({
    imports: [TermsOfUseMaterialModule, CommonModule, NgOptimizedImage],
    declarations: [TermsOfUseComponent],
    exports: [TermsOfUseComponent],
})
export class TermsOfUseModule {}
